import { Footer, type FooterTexts } from '@repo/pdx-ui/Footer';
import { getRetailerFromUrl } from '../../utils/getRetailerFromUrl';
import { rawString } from '../Language/Language';

/**
 * NarvarFooter wrapper that provides pdp-specific context to the
 * presentational Footer component from pdx-ui.
 */
export const NarvarFooter = () => {
  const retailerName = getRetailerFromUrl() ?? '';

  const texts: FooterTexts = {
    copyright: rawString({
      langKey: 'Global.footer.copyright',
      replacementTokens: { year: new Date().getFullYear().toString() },
    }),
    privacyPolicy: rawString({ langKey: 'Global.footer.privacyPolicy' }),
    privacyPolicyUrl: rawString({ langKey: 'Global.footer.privacyPolicyUrl' }),
    poweredBy: rawString({ langKey: 'Global.footer.poweredBy' }),
    // retailer_name param is used for tracking/analytics on corp.narvar.com
    surveyUrl: `https://corp.narvar.com/survey?product=pdx${retailerName ? '&retailer_name=${retailerName}' : ''}`,
  };

  return <Footer texts={texts} />;
};
